import { render, staticRenderFns } from "./ourServices.vue?vue&type=template&id=0936b22a&scoped=true"
import script from "./ourServices.vue?vue&type=script&lang=js"
export * from "./ourServices.vue?vue&type=script&lang=js"
import style0 from "./ourServices.vue?vue&type=style&index=0&id=0936b22a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0936b22a",
  null
  
)

export default component.exports